import { Dispatcher } from '@/APIDispatcher'
import {vm} from '@/main'

export const AdminApi = {
  nodes () {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('nodes/status', {}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.list)
        } else {
          vm.$notify.error('List Failed ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  inspectionsList (inspection) {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('inspections/list', {}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.list)
        } else {
          vm.$notify.error('List Failed ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  inspection (id) {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('inspection/get', { id }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.inspection)
        } else {
          vm.$notify.error('Save Failed ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  inspectionsSet (inspection) {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('inspections/set', inspection).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.inspection)
        } else {
          vm.$notify.error('Save Failed ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  inspectionResults (id) {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('inspection/results', { id }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.list)
        } else {
          vm.$notify.error('List Failed ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/admin/api.js